var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('KenticoResponsiveImage',{class:_vm.shape,attrs:{"src":_vm.image.url,"alt":_vm.image.description,"sizes":_vm.imageSizes}}),_vm._v(" "),_c(_vm.shape,{tag:"component",attrs:{"shape":_vm.shape}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }